<template>
    <div id="subheader" class="mapp-subheader" :class="{ sticky: percentMenu }">
        <div class="container-fluid container-xl d-flex align-items-center">
            <div class="mapp-subheader__row">
                <h1 class="mapp-subheader__title">{{ subHeaderText }}</h1>
                <div class="subheader_percent" v-if="this.percentMenu == true">
                    <div class="percent_progressbar">
                        <span class="progressbar_fill_percent" :style="{ width: subHeaderPercent + '%' }"></span>
                    </div>
                    {{ subHeaderPercent }}<span style="margin-top: 4px; font-size: 14px">%</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { useCookies } from 'vue3-cookies';

export default {
    name: 'SubHeader',

    data: function () {
        return {
            percentMenu: false,
            subHeaderPercent: 0,
            subHeaderText: '',
        };
    },

    setup() {
        const { cookies } = useCookies();
        return { cookies };
    },

    methods: {
        getCookie(val) {
            return this.cookies.get(val);
        },

        setSubHeaderPercent(status, percent) {
            if (status == true) {
                this.percentMenu = true;
                this.subHeaderPercent = percent;
            } else {
                this.percentMenu = false;
            }
        },
        setSubHeaderData(value) {
            this.subHeaderText = value;
        },
    },

    mounted() {
        // CHANGED_RESIZE window.addEventListener('resize', this.getDimensions);
        $('#subheader').css('display', 'flex'); //first show, then hide if needed
        var pagename = window.location.pathname.substr(1);

        if (pagename == '') {
            pagename = 'main';
        }
        if (pagename == 'main') {
            //document.getElementsByName("main-style")[0].innerHTML = "<style>#nav_main::before { width: 100%; }</style>";
            // "#437ca8"
            document.getElementById('subheader').style.display = 'none';
        }
        if (pagename == 'about') {
            this.subHeaderText = 'О сервисе';
        }
        if (pagename == 'contacts') {
            this.subHeaderText = 'Контакты';
        }
        if (pagename == 'order_history') {
            document.getElementsByName('order_history-style')[0].innerHTML =
                '<style>#nav_order_history::before { width: 100%; }</style>';
            document.getElementsByName('order_history')[0].style.color = '#437ca8';
            this.subHeaderText = 'История заказов';
            $('#header_width_div').css('width', '88.6vw');
            $('#subheader_width_div').css('width', '88.6vw');
        }
        if (pagename == 'new_orders') {
            document.getElementsByName('new_orders-style')[0].innerHTML =
                '<style>#nav_new_orders::before { width: 100%; }</style>';
            document.getElementsByName('new_orders')[0].style.color = '#437ca8';
            this.subHeaderText = 'Новые заказы';
            $('#header_width_div').css('width', '88.6vw');
            $('#subheader_width_div').css('width', '88.6vw');
        }
        if (pagename == 'order_data') {
            this.subHeaderText = 'Новая поездка';
        }
        if (pagename == 'my_orders') {
            if (!this.getCookie('mtu_refresh_token')) {
                document.location = '/authorization';
            }
            this.subHeaderText = 'Мои заказы';
        }
        if (pagename == 'order') {
            this.subHeaderText = 'Оформление заказа';
        }
        if (pagename == 'calculator') {
            this.subHeaderText = 'Предварительный расчёт';
        }
        if (pagename == 'account/forgot_password') {
            this.subHeaderText = 'Восстановление пароля';
        }
        if (pagename == 'carriers') {
            this.subHeaderText = 'Перевозчикам';
        }
        if (pagename == 'admin_page') {
            if (!this.getCookie('mtu_refresh_token')) {
                document.location = '/authorization';
            }
            document.getElementsByName('admin_page-style')[0].innerHTML =
                '<style>#nav_admin_page::before { width: 100%; }</style>';
            document.getElementsByName('admin_page')[0].style.color = '#437ca8';
            this.subHeaderText = 'Страница администратора';
        }
        if (pagename == 'authorization') {
            this.subHeaderText = 'Вход / Регистрация';
        }
        if (pagename == 'account') {
            if (!this.getCookie('mtu_refresh_token')) {
                document.location = '/authorization';
            }
            this.subHeaderText = 'Личный кабинет';
        }
        if (pagename == 'article') {
            this.subHeaderText = 'Статьи';
        }

        if (this.percentMenu) {
            this.$emit('status-updated', this.isFixable);
        }
    },
};
</script>

<style scoped src="@/assets/css/general.css"></style>
<style scoped src="@/assets/css/header.css"></style>

<style lang="scss">
.mapp-subheader {
    background-color: #0eccaa;
    min-height: 64px;

    &__row {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 4px 0;
        gap: 4px 18px;

        @media screen and (min-width: 992px) {
            flex-direction: row;
        }
    }

    &__title {
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        text-align: left;
        font-weight: 500 !important;
        font-size: 28px;
        line-height: 1;
        white-space: nowrap;
    }

    &.sticky {
        height: 30px;
        min-height: auto;
        .mapp-subheader__title {
            display: none;
        }
        @media screen and (min-width: 992px) {
            height: auto;
            min-height: 64px;
            .mapp-subheader__title {
                display: flex;
            }
        }
    }
}

.fixed .mapp-subheader.sticky {
    position: fixed;
    right: 0;
    left: 0;
    z-index: 9;
}

.fixed.animated .mapp-subheader.sticky {
    transition: all 0.3s;
}
</style>
